import React from 'react';

import { images } from '../../constants';
import '../../container/Header/Header.css';

const SubHeading = (props) => (
  <div className="❤️">
    <p className="p__cormorant">{props.title}</p>
    <img src={images.spoon} className="spoon__img" alt="spoon" />
  </div>
);

export default SubHeading;
